module.exports = "<div class=loading-message ng-show=\"vm.loading && !vm.suppressLoadingIndicator\"> <loadingindicator></loadingindicator> </div> <select ng-hide=\"vm.loading || vm.stores.length === 0\" ng-options=\"store as vm.storeLabel(store) for store in vm.stores\" ng-model=vm.selected ng-change=vm.select() ng-disabled=vm.disabled></select> <div ng-if=\"!vm.loading && vm.stores.length === 0\"> <p class=txt--warning>It appears that you have not been granted access to DriveTime. Please contact your DriveTime administrator to resolve this.</p> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/common/storeselector/template.html
// module id = 31
// module chunks = 0